// GENERATED by scripts/generate-render-color-token-defaults.js from
// styles/client/render-engine/scss/_tokens.scss - do NOT edit by hand.
// Re-run `node scripts/generate-render-color-token-defaults.js` after changing _tokens.scss.
//
// Every render-engine color token key -> its default value. The Render Theme editor backfills a
// brand's color token set with any missing keys from this map so the FULL palette is editable
// (so e.g. a catalog variant added in the layout editor has its colors editable too).
export var RenderColorTokenDefaults = {
    "bundle-details-banner-bundle-background": "#2961A7",
    "bundle-details-banner-bundle-country-foreground": "#fff",
    "bundle-details-banner-bundle-prize-foreground": "#fff",
    "bundle-details-banner-bundle-title-foreground": "#fff",
    "bundle-details-lotteries-lottery-background": "#f1f1f1",
    "bundle-details-lotteries-lottery-border": "#e0e0e0",
    "bundle-details-lotteries-lottery-button-edit-background": "#72b001",
    "bundle-details-lotteries-lottery-button-edit-background-hover": "#5b8a05",
    "bundle-details-lotteries-lottery-button-edit-foreground": "#ffffff",
    "bundle-details-lotteries-lottery-button-edit-foreground-hover": "#ffffff",
    "bundle-details-lotteries-lottery-button-random-background": "#2961A7",
    "bundle-details-lotteries-lottery-button-random-background-hover": "#144179",
    "bundle-details-lotteries-lottery-button-random-foreground": "#ffffff",
    "bundle-details-lotteries-lottery-button-random-foreground-hover": "#ffffff",
    "bundle-details-lotteries-lottery-foreground": "#3B4548",
    "bundle-details-lotteries-lottery-number-background": "#ffffff",
    "bundle-details-lotteries-lottery-number-bonus-background": "#fbc100",
    "bundle-details-lotteries-lottery-number-bonus-foreground": "#ffffff",
    "bundle-details-lotteries-lottery-number-border": "#cecece",
    "bundle-details-lotteries-lottery-number-foreground": "#3B4548",
    "bundle-details-sidebar-border": "#eee",
    "bundle-details-sidebar-draws-background": "#f2f2f2",
    "bundle-details-sidebar-draws-background-hover": "#fff",
    "bundle-details-sidebar-draws-background-selected": "#fff",
    "bundle-details-sidebar-draws-border": "#c9c9c9",
    "bundle-details-sidebar-draws-check-box-background": "#fff",
    "bundle-details-sidebar-draws-check-box-border": "#ccc",
    "bundle-details-sidebar-draws-check-box-selected-background": "#5cb85c",
    "bundle-details-sidebar-draws-check-box-selected-border": "#5cb85c",
    "bundle-details-sidebar-draws-check-box-tick-background": "#fff",
    "bundle-details-sidebar-draws-foreground": "#4a4a4a",
    "bundle-details-sidebar-draws-price-now-foreground": "#2961A7",
    "bundle-details-sidebar-draws-price-was-foreground": "#909090",
    "bundle-details-sidebar-draws-save-up-background": "#2961A7",
    "bundle-details-sidebar-draws-save-up-foreground": "#fff",
    "bundle-details-sidebar-summary-tickets-button-add-to-cart-background": "#05ce05",
    "bundle-details-sidebar-summary-tickets-button-add-to-cart-foreground": "#fff",
    "bundle-details-sidebar-summary-tickets-button-add-to-cart-hover-background": "#0df90d",
    "bundle-details-sidebar-summary-tickets-button-add-to-cart-hover-foreground": "#fff",
    "bundle-details-sidebar-summary-tickets-button-get-tickets-background": "#05ce05",
    "bundle-details-sidebar-summary-tickets-button-get-tickets-foreground": "#fff",
    "bundle-details-sidebar-summary-tickets-button-get-tickets-hover-background": "#0df90d",
    "bundle-details-sidebar-summary-tickets-button-get-tickets-hover-foreground": "#fff",
    "bundle-details-sidebar-summary-tickets-discount-foreground": "#38af38",
    "bundle-details-sidebar-summary-tickets-login-message-background": "#f0ad4e",
    "bundle-details-sidebar-summary-tickets-login-message-foreground": "#fff",
    "bundle-details-sidebar-summary-tickets-tickets-foreground": "#505050",
    "bundle-details-sidebar-summary-tickets-total-border": "#eee",
    "bundle-details-sidebar-summary-tickets-total-foreground": "#505050",
    "bundle-details-step-1-bundles-background": "#fff",
    "bundle-details-step-1-bundles-border": "#e0e0e0",
    "bundle-details-step-1-bundles-button-edit-background": "#72b001",
    "bundle-details-step-1-bundles-button-edit-background-hover": "#5b8a05",
    "bundle-details-step-1-bundles-button-edit-foreground": "#fff",
    "bundle-details-step-1-bundles-button-edit-foreground-hover": "#fff",
    "bundle-details-step-1-bundles-button-random-background": "#2961A7",
    "bundle-details-step-1-bundles-button-random-background-hover": "#144179",
    "bundle-details-step-1-bundles-button-random-foreground": "#fff",
    "bundle-details-step-1-bundles-button-random-foreground-hover": "#fff",
    "bundle-details-step-1-bundles-foreground": "#3B4548",
    "bundle-details-step-1-bundles-number-background": "#fff",
    "bundle-details-step-1-bundles-number-bonus-background": "#fbc100",
    "bundle-details-step-1-bundles-number-bonus-foreground": "#fff",
    "bundle-details-step-1-bundles-number-border": "#cecece",
    "bundle-details-step-1-bundles-number-foreground": "#3B4548",
    "bundle-details-step-1-quick-pick-background": "#72b001",
    "bundle-details-step-1-quick-pick-background-hover": "#5b8a05",
    "bundle-details-step-1-quick-pick-foreground": "#fff",
    "bundle-details-step-1-quick-pick-foreground-hover": "#fff",
    "bundle-details-step-2-draw-background": "#fff",
    "bundle-details-step-2-draw-background-shadow": "#2961A7",
    "bundle-details-step-2-draw-best-value-background": "#fff",
    "bundle-details-step-2-draw-best-value-background-shadow": "#fbc100",
    "bundle-details-step-2-draw-check-box-background": "#fff",
    "bundle-details-step-2-draw-check-box-border": "#ccc",
    "bundle-details-step-2-draw-check-box-selected-background": "#5cb85c",
    "bundle-details-step-2-draw-check-box-selected-border": "#5cb85c",
    "bundle-details-step-2-draw-check-box-tick-background": "#fff",
    "bundle-details-step-2-draw-cost-foreground": "#8c8b8b",
    "bundle-details-step-2-draw-number-foreground": "#3B4548",
    "bundle-details-step-2-draw-save-up-background": "#72b001",
    "bundle-details-step-2-draw-save-up-foreground": "#fff",
    "bundle-details-step-2-draws-background": "#f2f2f2",
    "bundle-details-step-3-purchase-tickets-background": "#2961A7",
    "bundle-details-step-3-purchase-tickets-button-add-to-cart-background": "#fbc100",
    "bundle-details-step-3-purchase-tickets-button-add-to-cart-foreground": "#3B4548",
    "bundle-details-step-3-purchase-tickets-button-add-to-cart-hover-background": "#e0ac00",
    "bundle-details-step-3-purchase-tickets-button-add-to-cart-hover-foreground": "#3B4548",
    "bundle-details-step-3-purchase-tickets-button-get-tickets-background": "#72b001",
    "bundle-details-step-3-purchase-tickets-button-get-tickets-foreground": "#fff",
    "bundle-details-step-3-purchase-tickets-button-get-tickets-hover-background": "#5b8a05",
    "bundle-details-step-3-purchase-tickets-button-get-tickets-hover-foreground": "#fff",
    "bundle-details-step-3-purchase-tickets-fallback-foreground": "#fff",
    "bundle-details-step-3-purchase-tickets-login-message-background": "#c0392b",
    "bundle-details-step-3-purchase-tickets-login-message-foreground": "#fff",
    "bundle-details-step-3-purchase-tickets-tickets-background": "#35507a",
    "bundle-details-step-3-purchase-tickets-tickets-foreground": "#fff",
    "bundle-details-step-3-purchase-tickets-total-foreground": "#fff",
    "bundle-details-step-count-background": "#2961A7",
    "bundle-details-step-count-foreground": "#fff",
    "bundle-details-step-title-foreground": "#3B4548",
    "bundle-game-information-desc-foreground": "#3B4548",
    "bundle-game-information-label-foreground": "#3B4548",
    "bundle-game-information-title-foreground": "#2961A7",
    "bundles-background": "#2961a7",
    "bundles-button-background": "#05ce05",
    "bundles-button-background-hover": "#0df90d",
    "bundles-button-foreground": "#ffffff",
    "bundles-button-foreground-hover": "#ffffff",
    "bundles-combobox-background": "#fbfbfb",
    "bundles-combobox-border": "#ddd",
    "bundles-combobox-foreground": "#4a4a4a",
    "bundles-combobox-icon": "#adadad",
    "bundles-combobox-label-foreground": "#9e9e9e",
    "bundles-foreground": "#ffffff",
    "bundles-show-more-foreground": "#e8120e",
    "bundles-title-foreground": "#2961A7",
    "cart-hottest-lotteries-background": "#d0232b",
    "cart-hottest-lotteries-details-digits-background": "#fff",
    "cart-hottest-lotteries-details-digits-foreground": "#000",
    "cart-hottest-lotteries-details-foreground": "#fff",
    "cart-hottest-lotteries-prize-amount-foreground": "#fff",
    "cart-hottest-lotteries-prize-button-background": "#000",
    "cart-hottest-lotteries-prize-button-foreground": "#fff",
    "cart-hottest-lotteries-prize-currency-foreground": "#fff",
    "cart-hottest-lotteries-title-foreground": "#e71511",
    "cart-lotteries-cart-check-out-background": "#ff9300",
    "cart-lotteries-cart-check-out-foreground": "#fff",
    "cart-lotteries-cart-check-out-hover-background": "#ef8a00",
    "cart-lotteries-cart-check-out-hover-foreground": "#fff",
    "cart-lotteries-cart-free-ticket-label-foreground": "#ffffff",
    "cart-lotteries-cart-free-tickets-title-foreground": "#ffffff",
    "cart-lotteries-cart-lottery-background": "#f8f8f8",
    "cart-lotteries-cart-lottery-border": "#f8f8f8",
    "cart-lotteries-cart-lottery-button-show-lines-background": "#ececec",
    "cart-lotteries-cart-lottery-button-show-lines-foreground": "#3f3d40",
    "cart-lotteries-cart-lottery-button-show-lines-hover-background": "#e0e0e0",
    "cart-lotteries-cart-lottery-button-show-lines-hover-foreground": "#3f3d40",
    "cart-lotteries-cart-lottery-column-label-foreground": "#3f3d40",
    "cart-lotteries-cart-lottery-date-foreground": "#8c8b8b",
    "cart-lotteries-cart-lottery-draws-foreground": "#8c8b8b",
    "cart-lotteries-cart-lottery-hover-background": "#f8f8f8",
    "cart-lotteries-cart-lottery-icon-arrow-foreground": "#b5b4b6",
    "cart-lotteries-cart-lottery-icon-edit-foreground": "#3bcf01",
    "cart-lotteries-cart-lottery-icon-edit-hover-foreground": "#03af03",
    "cart-lotteries-cart-lottery-icon-remove-foreground": "#d0232b",
    "cart-lotteries-cart-lottery-icon-remove-hover-foreground": "#ff0000",
    "cart-lotteries-cart-lottery-info-foreground": "#8c8b8b",
    "cart-lotteries-cart-lottery-line-border": "#f8f8f8",
    "cart-lotteries-cart-lottery-lines-foreground": "#8c8b8b",
    "cart-lotteries-cart-lottery-login-message-background": "#f0ad4e",
    "cart-lotteries-cart-lottery-login-message-foreground": "#fff",
    "cart-lotteries-cart-lottery-name-foreground": "#3f3d40",
    "cart-lotteries-cart-lottery-number-background": "#f2eeeb",
    "cart-lotteries-cart-lottery-number-bonus-background": "#164D93",
    "cart-lotteries-cart-lottery-number-bonus-foreground": "#fff",
    "cart-lotteries-cart-lottery-number-foreground": "#343e4c",
    "cart-lotteries-cart-lottery-price-foreground": "#3f3d40",
    "cart-lotteries-cart-lottery-subscribe-foreground": "#3bcf01",
    "cart-lotteries-cart-savings-amount-foreground": "#ffffff",
    "cart-lotteries-cart-savings-label-foreground": "#ffffff",
    "cart-lotteries-cart-secured-payment-border": "#d1d2d3",
    "cart-lotteries-cart-secured-payment-foreground": "#3f3d40",
    "cart-lotteries-cart-secured-payment-ssl-foreground": "#05ce05",
    "cart-lotteries-cart-signin-foreground": "#337ab7",
    "cart-lotteries-cart-sub-total-border": "#d1d2d3",
    "cart-lotteries-cart-sub-total-foreground": "#3B4548",
    "cart-lotteries-cart-title-border": "#d1d2d3",
    "cart-lotteries-cart-title-foreground": "#4677c4",
    "cart-lotteries-cart-total-amount-foreground": "#3f3d40",
    "cart-lotteries-cart-total-box-background": "#fafafa",
    "cart-lotteries-cart-total-box-border": "#d1d2d3",
    "cart-lotteries-cart-total-box-foreground": "#3f3d40",
    "cart-terms-and-conditions-foreground": "#ad8686",
    "lobby-banner-lottery-background": "#ab171e",
    "lobby-banner-lottery-details-digits-background": "#fff",
    "lobby-banner-lottery-details-digits-foreground": "#ab171e",
    "lobby-banner-lottery-details-foreground": "#fff",
    "lobby-banner-lottery-prize-button-background": "#fff",
    "lobby-banner-lottery-prize-button-foreground": "#ab171e",
    "lobby-banner-lottery-prize-button-hover-background": "#770f14",
    "lobby-banner-lottery-prize-button-hover-foreground": "#fff",
    "lobby-banner-lottery-prize-foreground": "#fff",
    "lobby-bundles-background": "#2961a7",
    "lobby-bundles-button-background": "#05ce05",
    "lobby-bundles-button-background-hover": "#0df90d",
    "lobby-bundles-button-foreground": "#ffffff",
    "lobby-bundles-button-foreground-hover": "#ffffff",
    "lobby-bundles-foreground": "#ffffff",
    "lobby-bundles-show-more-foreground": "#e8120e",
    "lobby-bundles-title-foreground": "#2961A7",
    "lobby-carousel-lotteries-arrow-icon-background": "#f5f5f5",
    "lobby-carousel-lotteries-arrow-icon-foreground": "#4a4a4a",
    "lobby-carousel-lotteries-lottery-content-background": "#2961A7",
    "lobby-carousel-lotteries-lottery-content-country-foreground": "#fff",
    "lobby-carousel-lotteries-lottery-content-name-foreground": "#fff",
    "lobby-carousel-lotteries-lottery-content-next-draw-foreground": "#fff",
    "lobby-carousel-lotteries-lottery-content-prize-foreground": "#fff",
    "lobby-carousel-lotteries-lottery-footer-background": "#f5f5f5",
    "lobby-carousel-lotteries-lottery-footer-button-background": "#05ce05",
    "lobby-carousel-lotteries-lottery-footer-button-foreground": "#fff",
    "lobby-carousel-lotteries-lottery-footer-button-hover-background": "#01af01",
    "lobby-carousel-lotteries-lottery-footer-button-hover-foreground": "#fff",
    "lobby-fold-background": "#2961A7",
    "lobby-fold-button-subscribe-background": "#38af38",
    "lobby-fold-button-subscribe-background-hover": "#009800",
    "lobby-fold-button-subscribe-foreground": "#fff",
    "lobby-fold-button-subscribe-foreground-hover": "#fff",
    "lobby-fold-jackpot-background": "#2961A7",
    "lobby-fold-jackpot-button-background": "#05ce05",
    "lobby-fold-jackpot-button-foreground": "#fff",
    "lobby-fold-jackpot-button-hover-background": "#01af01",
    "lobby-fold-jackpot-button-hover-foreground": "#fff",
    "lobby-fold-jackpot-next-draw-foreground": "#fff",
    "lobby-fold-jackpot-prize-foreground": "#fff",
    "lobby-fold-jackpot-subscribe-foreground": "#fff",
    "lobby-fold-jackpot-time-remaining-border": "#fff",
    "lobby-fold-jackpot-time-remaining-foreground": "#fff",
    "lobby-fold-jackpot-title-foreground": "#fff",
    "lobby-header-background": "#f8f8f8",
    "lobby-header-cart-count-background": "#d0232b",
    "lobby-header-cart-count-foreground": "#fff",
    "lobby-header-navigation-fab-cart-background": "#000",
    "lobby-header-navigation-fab-cart-foreground": "#fff",
    "lobby-header-navigation-nav-background": "#f8f8f8",
    "lobby-header-navigation-nav-background-hover": "#f8f8f8",
    "lobby-header-navigation-nav-divider": "#b4b4b4",
    "lobby-header-navigation-nav-foreground": "#223756",
    "lobby-header-navigation-nav-foreground-hover": "#00d400",
    "lobby-header-navigation-nav-selected-background": "#f8f8f8",
    "lobby-header-navigation-nav-selected-foreground": "#2961A7",
    "lobby-header-purchase-count-background": "#5cb85c",
    "lobby-header-purchase-count-foreground": "#fff",
    "lobby-how-to-play-title-foreground": "#213755",
    "lobby-instant-game-cards-card-cta-background": "#e8120e",
    "lobby-instant-game-cards-card-cta-background-hover": "#ed2c28",
    "lobby-instant-game-cards-card-cta-foreground": "#ffffff",
    "lobby-instant-game-cards-card-cta-foreground-hover": "#ffffff",
    "lobby-instant-game-cards-card-details-background": "#ffffff",
    "lobby-instant-game-cards-card-price-foreground": "#283d8c",
    "lobby-instant-game-cards-card-title-foreground": "#283d8c",
    "lobby-instant-game-cards-title": "#283d8c",
    "lobby-instant-games-background": "#ffffff",
    "lobby-instant-games-button-background": "#05ce05",
    "lobby-instant-games-button-background-hover": "#0df90d",
    "lobby-instant-games-button-foreground": "#ffffff",
    "lobby-instant-games-button-foreground-hover": "#ffffff",
    "lobby-instant-games-title-foreground": "#2961A7",
    "lobby-latest-results-all-results-foreground": "#2961A7",
    "lobby-latest-results-background": "#F5F5F5",
    "lobby-latest-results-border": "#d1d2d3",
    "lobby-latest-results-button-background": "#67a608",
    "lobby-latest-results-button-foreground": "#fff",
    "lobby-latest-results-button-hover-background": "#82c71a",
    "lobby-latest-results-button-hover-foreground": "#fff",
    "lobby-latest-results-country-foreground": "#434d52",
    "lobby-latest-results-date-foreground": "#434d52",
    "lobby-latest-results-name-foreground": "#434d52",
    "lobby-latest-results-num-background": "#0830F4",
    "lobby-latest-results-num-bonus-background": "#FFBA02",
    "lobby-latest-results-num-bonus-foreground": "#fff",
    "lobby-latest-results-num-border": "#0830F4",
    "lobby-latest-results-num-foreground": "#fff",
    "lobby-latest-results-prize-foreground": "#3B4548",
    "lobby-latest-results-title-foreground": "#213755",
    "lobby-lotteries-lottery-background": "#f5f5f5",
    "lobby-lotteries-lottery-button-background": "#05ce05",
    "lobby-lotteries-lottery-button-foreground": "#fff",
    "lobby-lotteries-lottery-button-hover-background": "#01af01",
    "lobby-lotteries-lottery-button-hover-foreground": "#fff",
    "lobby-lotteries-lottery-card-background": "#ebebeb",
    "lobby-lotteries-lottery-card-content-background": "#4a4a4a",
    "lobby-lotteries-lottery-card-country-foreground": "#ffffff",
    "lobby-lotteries-lottery-card-date-foreground": "#ffffff",
    "lobby-lotteries-lottery-card-footer-date-foreground": "#ffffff",
    "lobby-lotteries-lottery-card-jackpot-amount-foreground": "#ffffff",
    "lobby-lotteries-lottery-card-name-foreground": "#ffffff",
    "lobby-lotteries-lottery-country-foreground": "#3B4548",
    "lobby-lotteries-lottery-name-foreground": "#3B4548",
    "lobby-lotteries-lottery-next-draw-foreground": "#3B4548",
    "lobby-lotteries-lottery-num-background": "#0830F4",
    "lobby-lotteries-lottery-num-bonus-background": "#FFBA02",
    "lobby-lotteries-lottery-num-bonus-foreground": "#ffffff",
    "lobby-lotteries-lottery-num-foreground": "#ffffff",
    "lobby-lotteries-lottery-prize-foreground": "#3B4548",
    "lobby-lotteries-show-more-foreground": "#67a608",
    "lobby-lotteries-stories-closing-background": "#d9534f",
    "lobby-lotteries-stories-closing-foreground": "#fff",
    "lobby-lotteries-stories-jackpot-foreground": "#3B4548",
    "lobby-lotteries-sub-title": "#3B4548",
    "lobby-lotteries-title": "#0b3684",
    "lobby-quick-play-background": "#2e6db0",
    "lobby-quick-play-choose-tickets-add-line-background": "#fff",
    "lobby-quick-play-choose-tickets-add-line-background-hover": "#fff",
    "lobby-quick-play-choose-tickets-add-line-foreground": "#2e6db0",
    "lobby-quick-play-choose-tickets-add-line-foreground-hover": "#2e6db0",
    "lobby-quick-play-choose-tickets-button-cart-background": "#05ce05",
    "lobby-quick-play-choose-tickets-button-cart-foreground": "#fff",
    "lobby-quick-play-choose-tickets-button-cart-hover-background": "#01af01",
    "lobby-quick-play-choose-tickets-button-cart-hover-foreground": "#fff",
    "lobby-quick-play-choose-tickets-button-get-background": "#05ce05",
    "lobby-quick-play-choose-tickets-button-get-foreground": "#fff",
    "lobby-quick-play-choose-tickets-button-get-hover-background": "#01af01",
    "lobby-quick-play-choose-tickets-button-get-hover-foreground": "#fff",
    "lobby-quick-play-choose-tickets-delete-icon-foreground": "#db0000",
    "lobby-quick-play-choose-tickets-discount-label-foreground": "#67a608",
    "lobby-quick-play-choose-tickets-discount-value-foreground": "#67a608",
    "lobby-quick-play-choose-tickets-draw-background": "#fff",
    "lobby-quick-play-choose-tickets-draw-border": "#2e6db0",
    "lobby-quick-play-choose-tickets-draw-foreground": "#3B4548",
    "lobby-quick-play-choose-tickets-draw-selected-background": "#2e6db0",
    "lobby-quick-play-choose-tickets-draw-selected-border": "#2e6db0",
    "lobby-quick-play-choose-tickets-draw-selected-foreground": "#fff",
    "lobby-quick-play-choose-tickets-draws-background": "#fff",
    "lobby-quick-play-choose-tickets-draws-label-foreground": "#3B4548",
    "lobby-quick-play-choose-tickets-header-date-foreground": "#fff",
    "lobby-quick-play-choose-tickets-header-prize-foreground": "#fff",
    "lobby-quick-play-choose-tickets-header-title-foreground": "#fff",
    "lobby-quick-play-choose-tickets-line-background": "#fff",
    "lobby-quick-play-choose-tickets-line-draw-border-color": "#eeeeee",
    "lobby-quick-play-choose-tickets-line-draw-foreground": "#3B4548",
    "lobby-quick-play-choose-tickets-line-num-background": "#164D93",
    "lobby-quick-play-choose-tickets-line-num-bonus-background": "#ffba02",
    "lobby-quick-play-choose-tickets-line-num-bonus-foreground": "#fff",
    "lobby-quick-play-choose-tickets-line-num-foreground": "#fff",
    "lobby-quick-play-choose-tickets-login-message-background": "#f0ad4e",
    "lobby-quick-play-choose-tickets-login-message-foreground": "#fff",
    "lobby-quick-play-choose-tickets-total-label-foreground": "#3B4548",
    "lobby-quick-play-choose-tickets-total-value-foreground": "#3B4548",
    "lobby-quick-play-desc-foreground": "#fff",
    "lobby-quick-play-lotteries-jackpot-foreground": "#fff",
    "lobby-quick-play-title-foreground": "#fff",
    "lobby-scratch-cards-carousel-card-price-background": "#ab171e",
    "lobby-scratch-cards-carousel-card-price-foreground": "#ffffff",
    "lobby-scratch-cards-carousel-card-title-foreground": "#3B4548",
    "lobby-scratch-cards-carousel-title": "#283d8c",
    "lobby-template-background": "#ffffff",
    "lobby-terms-and-conditions-foreground": "#000",
    "lotteries-combobox-background": "#fbfbfb",
    "lotteries-combobox-border": "#ddd",
    "lotteries-combobox-foreground": "#4a4a4a",
    "lotteries-combobox-icon": "#adadad",
    "lotteries-combobox-label-foreground": "#9e9e9e",
    "lotteries-lottery-background": "#f5f5f5",
    "lotteries-lottery-button-background": "#05ce05",
    "lotteries-lottery-button-foreground": "#fff",
    "lotteries-lottery-button-hover-background": "#01af01",
    "lotteries-lottery-button-hover-foreground": "#fff",
    "lotteries-lottery-country-foreground": "#3B4548",
    "lotteries-lottery-name-foreground": "#3B4548",
    "lotteries-lottery-next-draw-foreground": "#3B4548",
    "lotteries-lottery-prize-foreground": "#3B4548",
    "lotteries-show-more-foreground": "#67a608",
    "lotteries-sub-title": "#3B4548",
    "lotteries-title": "#0b3684",
    "lottery-banner-amount-foreground": "#fff",
    "lottery-banner-background": "#164D93",
    "lottery-banner-country-foreground": "#fff",
    "lottery-banner-multiplier-value-foreground": "#fff",
    "lottery-banner-next-draw-foreground": "#fff",
    "lottery-banner-subscription-background": "#EBEBEB",
    "lottery-banner-subscription-foreground": "#333",
    "lottery-banner-subscription-price-border": "#333",
    "lottery-banner-title-foreground": "#fff",
    "lottery-bonus-background": "transparent",
    "lottery-button-add-lines-background": "#05ce05",
    "lottery-button-add-lines-foreground": "#fff",
    "lottery-button-remove-lines-background": "#05ce05",
    "lottery-button-remove-lines-foreground": "#fff",
    "lottery-carousel-lotteries-arrow-icon-background": "#f5f5f5",
    "lottery-carousel-lotteries-arrow-icon-foreground": "#4a4a4a",
    "lottery-carousel-lotteries-closing-soon-background": "#d9534f",
    "lottery-carousel-lotteries-closing-soon-foreground": "#ffffff",
    "lottery-carousel-lotteries-jackpot-foreground": "#4a4a4a",
    "lottery-carousel-lotteries-play-now-background": "#67a608",
    "lottery-carousel-lotteries-play-now-foreground": "#ffffff",
    "lottery-choose-ticket-button-background": "#04ce04",
    "lottery-choose-ticket-button-background-hover": "#03af03",
    "lottery-choose-ticket-button-foreground": "#fff",
    "lottery-choose-ticket-button-foreground-hover": "#fff",
    "lottery-choose-tickets-border": "#eee",
    "lottery-choose-tickets-update-cart-button-background": "#05ce05",
    "lottery-choose-tickets-update-cart-button-foreground": "#fff",
    "lottery-choose-tickets-update-cart-button-hover-background": "#01af01",
    "lottery-choose-tickets-update-cart-button-hover-foreground": "#fff",
    "lottery-draw-background": "#f2f2f2",
    "lottery-draw-background-hover": "#fff",
    "lottery-draw-background-selected": "#fff",
    "lottery-draw-background-shadow": "#9c9c9c",
    "lottery-draw-best-value-background": "#2961A7",
    "lottery-draw-best-value-background-shadow": "#9c9c9c",
    "lottery-draw-best-value-foreground": "#fff",
    "lottery-draw-border": "#c9c9c9",
    "lottery-draw-check-box-background": "#fff",
    "lottery-draw-check-box-border": "#ccc",
    "lottery-draw-check-box-selected-background": "#5cb85c",
    "lottery-draw-check-box-selected-border": "#5cb85c",
    "lottery-draw-check-box-tick-background": "#fff",
    "lottery-draw-cost-foreground": "#3B4548",
    "lottery-draw-foreground": "#4a4a4a",
    "lottery-draw-number-foreground": "#3B4548",
    "lottery-draw-price-now-foreground": "#2961A7",
    "lottery-draw-price-was-foreground": "#909090",
    "lottery-draw-save-up-background": "#67a608",
    "lottery-draw-save-up-foreground": "#fff",
    "lottery-draw-winning-label-foreground": "#878787",
    "lottery-draw-winning-progress-bar-background": "#f1f1f1",
    "lottery-draw-winning-progress-bar-selected-background": "#67A608",
    "lottery-draw-winning-progress-bar-selected-opacity-background": "#67A608",
    "lottery-draws-background": "#dedede",
    "lottery-erase-background": "#d0232b",
    "lottery-erase-foreground": "#fff",
    "lottery-erase-hover-background": "#9e0209",
    "lottery-erase-hover-foreground": "#fff",
    "lottery-free-ticket-net-total-foreground": "#ffd700",
    "lottery-free-ticket-savings-foreground": "#ffd700",
    "lottery-free-ticket-toggle-foreground": "#ffd700",
    "lottery-free-tickets-banner-background": "#000000",
    "lottery-free-tickets-banner-border": "#ffc800",
    "lottery-free-tickets-banner-foreground": "#ffd700",
    "lottery-free-tickets-banner-zero-foreground": "#ff6b6b",
    "lottery-game-information-background": "#ffffff",
    "lottery-game-information-border": "#ddd",
    "lottery-game-information-content-desc-foreground": "#4a4a4a",
    "lottery-game-information-content-link-foreground": "#2961A7",
    "lottery-game-information-content-title-foreground": "#2961A7",
    "lottery-game-information-description-foreground-desktop": "#4a4a4a",
    "lottery-game-information-header-arrow-background": "#2961A7",
    "lottery-game-information-header-arrow-foreground": "#ffffff",
    "lottery-game-information-header-title-foreground": "#2961A7",
    "lottery-game-information-sub-title-foreground-desktop": "#2961A7",
    "lottery-game-information-title-foreground-desktop": "#2961A7",
    "lottery-game-information-title-foreground-mobile": "#2961A7",
    "lottery-header-lottery-background": "#164D93",
    "lottery-header-lottery-multiplier-background": "#fff",
    "lottery-header-lottery-multiplier-background-active": "#67a608",
    "lottery-header-lottery-multiplier-thumb-background": "#fff",
    "lottery-header-lottery-multiplier-value-foreground": "#fff",
    "lottery-header-lottery-next-draw-foreground": "#fff",
    "lottery-header-lottery-prize-border": "#fff",
    "lottery-header-lottery-prize-foreground": "#fff",
    "lottery-header-lottery-title-foreground": "#fff",
    "lottery-hottest-lotteries-background": "#2961A7",
    "lottery-hottest-lotteries-details-digits-background": "#fff",
    "lottery-hottest-lotteries-details-digits-foreground": "#000",
    "lottery-hottest-lotteries-details-foreground": "#fff",
    "lottery-hottest-lotteries-prize-amount-foreground": "#fff",
    "lottery-hottest-lotteries-prize-button-background": "#000",
    "lottery-hottest-lotteries-prize-button-foreground": "#fff",
    "lottery-hottest-lotteries-prize-currency-foreground": "#fff",
    "lottery-hottest-lotteries-title-foreground": "#888",
    "lottery-lotteries-jackpot-foreground": "#4a4a4a",
    "lottery-mobile-ticket-add-line-background": "#fff",
    "lottery-mobile-ticket-add-line-foreground": "#164D93",
    "lottery-mobile-ticket-button-add-background": "#ffffff",
    "lottery-mobile-ticket-button-add-foreground": "#164D93",
    "lottery-mobile-ticket-button-buy-background": "#82c71a",
    "lottery-mobile-ticket-button-buy-foreground": "#ffffff",
    "lottery-mobile-ticket-button-pick-numbers-background": "#ffffff",
    "lottery-mobile-ticket-button-pick-numbers-foreground": "#164D93",
    "lottery-mobile-ticket-discount-border": "#eeeeee",
    "lottery-mobile-ticket-discount-foreground": "#67a608",
    "lottery-mobile-ticket-draws-background": "#ffffff",
    "lottery-mobile-ticket-draws-draw-background": "#ffffff",
    "lottery-mobile-ticket-draws-draw-background-selected": "#2e6db0",
    "lottery-mobile-ticket-draws-draw-border": "#2e6db0",
    "lottery-mobile-ticket-draws-draw-border-selected": "#2e6db0",
    "lottery-mobile-ticket-draws-draw-foreground": "#3B4548",
    "lottery-mobile-ticket-draws-draw-foreground-selected": "#ffffff",
    "lottery-mobile-ticket-draws-label-foreground": "#3B4548",
    "lottery-mobile-ticket-line-background": "#fff",
    "lottery-mobile-ticket-line-delete-foreground": "#d52731",
    "lottery-mobile-ticket-line-draws-border": "#eeeeee",
    "lottery-mobile-ticket-line-draws-foreground": "#3B4548",
    "lottery-mobile-ticket-line-num-background": "#164D93",
    "lottery-mobile-ticket-line-num-bonus-background": "#ffba02",
    "lottery-mobile-ticket-line-num-bonus-foreground": "#fff",
    "lottery-mobile-ticket-line-num-foreground": "#fff",
    "lottery-mobile-ticket-login-message-background": "#f0ad4e",
    "lottery-mobile-ticket-login-message-foreground": "#ffffff",
    "lottery-mobile-ticket-lottery-background": "#164D93",
    "lottery-mobile-ticket-lottery-title-foreground": "#ffffff",
    "lottery-mobile-ticket-total-foreground": "#3B4548",
    "lottery-prize-breakdown-table-border": "#eee",
    "lottery-prize-breakdown-table-title-foreground": "#2961A7",
    "lottery-prize-breakdown-table-value-foreground": "#4a4a4a",
    "lottery-prize-breakdown-title-foreground": "#2961A7",
    "lottery-purchase-tickets-background": "#dedede",
    "lottery-purchase-tickets-button-add-to-cart-background": "#05ce05",
    "lottery-purchase-tickets-button-add-to-cart-foreground": "#fff",
    "lottery-purchase-tickets-button-add-to-cart-hover-background": "#0df90d",
    "lottery-purchase-tickets-button-add-to-cart-hover-foreground": "#fff",
    "lottery-purchase-tickets-button-get-tickets-background": "#05ce05",
    "lottery-purchase-tickets-button-get-tickets-foreground": "#fff",
    "lottery-purchase-tickets-button-get-tickets-hover-background": "#0df90d",
    "lottery-purchase-tickets-button-get-tickets-hover-foreground": "#fff",
    "lottery-purchase-tickets-discount-foreground": "#38af38",
    "lottery-purchase-tickets-fallback-foreground": "#505050",
    "lottery-purchase-tickets-login-message-background": "#f0ad4e",
    "lottery-purchase-tickets-login-message-foreground": "#fff",
    "lottery-purchase-tickets-tickets-background": "#fff",
    "lottery-purchase-tickets-tickets-foreground": "#505050",
    "lottery-purchase-tickets-total-border": "#eee",
    "lottery-purchase-tickets-total-foreground": "#505050",
    "lottery-quick-pick-background": "#05ce05",
    "lottery-quick-pick-foreground": "#fff",
    "lottery-quick-pick-hover-background": "#0df90d",
    "lottery-quick-pick-hover-foreground": "#fff",
    "lottery-quick-pick-icon-erase-foreground": "#fff",
    "lottery-step-count-background": "#d0232b",
    "lottery-step-count-foreground": "#fff",
    "lottery-step-title-foreground": "#d0232b",
    "lottery-switch-pages-background": "#e6e6e6",
    "lottery-switch-pages-foreground": "#3B4548",
    "lottery-switch-pages-selected-background": "#164D93",
    "lottery-switch-pages-selected-foreground": "#fff",
    "lottery-ticket-background": "#fff",
    "lottery-ticket-bonus-number-background": "#fff",
    "lottery-ticket-bonus-number-border": "#2a2a2a",
    "lottery-ticket-bonus-number-selected-background": "#ecbe13",
    "lottery-ticket-bonus-number-selected-foreground": "#fff",
    "lottery-ticket-bonus-pick-numbers-background": "#f1f1f1",
    "lottery-ticket-bonus-pick-numbers-foreground": "#4a4a4a",
    "lottery-ticket-border": "#adadad",
    "lottery-ticket-erase-background": "#2961A7",
    "lottery-ticket-erase-foreground": "#fff",
    "lottery-ticket-erase-hover-background": "#164D93",
    "lottery-ticket-erase-hover-foreground": "#fff",
    "lottery-ticket-main-number-background": "#fff",
    "lottery-ticket-main-number-border": "#adadad",
    "lottery-ticket-main-number-selected-background": "#2961A7",
    "lottery-ticket-main-number-selected-foreground": "#fff",
    "lottery-ticket-pick-numbers-background": "#f1f1f1",
    "lottery-ticket-pick-numbers-completed-background": "#2bca17",
    "lottery-ticket-pick-numbers-completed-foreground": "#ffffff",
    "lottery-ticket-pick-numbers-foreground": "#4a4a4a",
    "lottery-ticket-pick-random-background": "#2961A7",
    "lottery-ticket-pick-random-foreground": "#fff",
    "lottery-ticket-pick-random-hover-background": "#164D93",
    "lottery-ticket-pick-random-hover-foreground": "#fff",
    "overlay-overlay-close-background": "#3c3c3c",
    "overlay-overlay-close-background-hover": "#d9534f",
    "overlay-overlay-close-foreground": "#ffffff",
    "overlay-overlay-close-foreground-hover": "#ffffff",
    "overlay-overlay-landing-lottery-background": "#F29A0A",
    "overlay-overlay-landing-lottery-button-background": "#D0222B",
    "overlay-overlay-landing-lottery-button-background-hover": "#a41b22",
    "overlay-overlay-landing-lottery-button-foreground": "#ffffff",
    "overlay-overlay-landing-lottery-button-foreground-hover": "#ffffff",
    "overlay-overlay-landing-lottery-name-foreground": "#ffffff",
    "overlay-overlay-landing-lottery-prize-foreground": "#ffffff",
    "overlay-overlay-landing-nav-background": "#1d1d1b",
    "overlay-overlay-landing-nav-background-hover": "#3a3a36",
    "overlay-overlay-landing-nav-background-selected": "#F29A0A",
    "overlay-overlay-landing-nav-background-selected-hover": "#ca7d00",
    "overlay-overlay-landing-nav-count-background": "#D0222B",
    "overlay-overlay-landing-nav-count-foreground": "#ffffff",
    "overlay-overlay-landing-nav-foreground": "#ffffff",
    "overlay-overlay-landing-nav-foreground-hover": "#ffffff",
    "overlay-overlay-landing-nav-foreground-selected": "#1d1d1b",
    "overlay-overlay-landing-nav-foreground-selected-hover": "#1d1d1b",
    "overlay-overlay-landing-powered-by-background": "#f1f1f1",
    "overlay-overlay-landing-powered-by-foreground": "#3B4548",
    "purchases-hottest-lotteries-background": "#d0232b",
    "purchases-hottest-lotteries-details-digits-background": "#fff",
    "purchases-hottest-lotteries-details-digits-foreground": "#000",
    "purchases-hottest-lotteries-details-foreground": "#fff",
    "purchases-hottest-lotteries-prize-amount-foreground": "#fff",
    "purchases-hottest-lotteries-prize-button-background": "#000",
    "purchases-hottest-lotteries-prize-button-foreground": "#fff",
    "purchases-hottest-lotteries-prize-currency-foreground": "#fff",
    "purchases-hottest-lotteries-title-foreground": "#e71511",
    "purchases-lotteries-lottery-background": "#f5f5f5",
    "purchases-lotteries-lottery-label-foreground": "#3B4548",
    "purchases-lotteries-lottery-name-foreground": "#3B4548",
    "purchases-lotteries-lottery-number-background": "#fff",
    "purchases-lotteries-lottery-secure-transaction-background": "#dcdcdc",
    "purchases-lotteries-lottery-status-foreground": "#3B4548",
    "purchases-lotteries-lottery-tickets-details-background": "#fff",
    "purchases-lotteries-lottery-tickets-details-border": "#f8f8f8",
    "purchases-lotteries-lottery-tickets-ticket-border": "#DDDDDD",
    "purchases-lotteries-lottery-tickets-ticket-button-background": "#67a608",
    "purchases-lotteries-lottery-tickets-ticket-button-foreground": "#fff",
    "purchases-lotteries-lottery-tickets-ticket-button-hover-background": "#81cc10",
    "purchases-lotteries-lottery-tickets-ticket-button-hover-foreground": "#fff",
    "purchases-lotteries-lottery-tickets-ticket-label-foreground": "#3B4548",
    "purchases-lotteries-lottery-tickets-ticket-number-background": "#f2eeeb",
    "purchases-lotteries-lottery-tickets-ticket-number-bonus-background": "#164D93",
    "purchases-lotteries-lottery-tickets-ticket-number-bonus-foreground": "#fff",
    "purchases-lotteries-lottery-tickets-ticket-number-border": "#fff",
    "purchases-lotteries-lottery-tickets-ticket-number-foreground": "#343e4c",
    "purchases-lotteries-lottery-tickets-ticket-status-nowin": "#d0232b",
    "purchases-lotteries-lottery-tickets-ticket-status-pending": "#ffa41a",
    "purchases-lotteries-lottery-tickets-ticket-status-winner": "#049e04",
    "purchases-lotteries-title": "#2961A7",
    "results-bottom-description": "#3B4548",
    "results-hottest-lotteries-background": "#d0232b",
    "results-hottest-lotteries-details-digits-background": "#fff",
    "results-hottest-lotteries-details-digits-foreground": "#000",
    "results-hottest-lotteries-details-foreground": "#fff",
    "results-hottest-lotteries-prize-amount-foreground": "#fff",
    "results-hottest-lotteries-prize-button-background": "#000",
    "results-hottest-lotteries-prize-button-foreground": "#fff",
    "results-hottest-lotteries-prize-currency-foreground": "#fff",
    "results-hottest-lotteries-title-foreground": "#e71511",
    "results-lotteries-combobox-background": "#fbfbfb",
    "results-lotteries-combobox-border": "#ddd",
    "results-lotteries-combobox-foreground": "#4a4a4a",
    "results-lotteries-combobox-icon": "#adadad",
    "results-lotteries-combobox-label-foreground": "#9e9e9e",
    "results-lotteries-lottery-background": "#f5f5f5",
    "results-lotteries-lottery-bonus-number-background": "#ecbe13",
    "results-lotteries-lottery-bonus-number-foreground": "#3d3d3d",
    "results-lotteries-lottery-border": "#ebebeb",
    "results-lotteries-lottery-button-background": "#05ce05",
    "results-lotteries-lottery-button-foreground": "#fff",
    "results-lotteries-lottery-button-hover-background": "#01af01",
    "results-lotteries-lottery-button-hover-foreground": "#fff",
    "results-lotteries-lottery-country-foreground": "#3B4548",
    "results-lotteries-lottery-name-foreground": "#3B4548",
    "results-lotteries-lottery-next-draw-foreground": "#3B4548",
    "results-lotteries-lottery-number-background": "#2961A7",
    "results-lotteries-lottery-number-border": "#eee",
    "results-lotteries-lottery-number-foreground": "#ffffff",
    "results-lotteries-lottery-prize-foreground": "#3B4548",
    "results-lotteries-lottery-result-details-background": "#fff",
    "results-lotteries-lottery-result-details-border": "#f8f8f8",
    "results-lotteries-lottery-result-details-expand-icon-color": "#164D93",
    "results-lotteries-lottery-result-details-foreground": "#3B4548",
    "results-lotteries-title": "#2961A7",
    "syndicate-banner-background": "#164D93",
    "syndicate-banner-country-foreground": "#ffffff",
    "syndicate-banner-next-draw-foreground": "#ffffff",
    "syndicate-banner-prize-foreground": "#ffffff",
    "syndicate-banner-title-foreground": "#ffffff",
    "syndicate-carousel-arrow-icon-background": "#f5f5f5",
    "syndicate-carousel-arrow-icon-foreground": "#4a4a4a",
    "syndicate-carousel-available-shares-foreground": "#3B4548",
    "syndicate-carousel-available-shares-selected-foreground": "#fff",
    "syndicate-carousel-combined-lines-foreground": "#3B4548",
    "syndicate-carousel-combined-lines-selected-foreground": "#fff",
    "syndicate-carousel-content-background": "#f1f1f1",
    "syndicate-carousel-content-selected-background": "#164D93",
    "syndicate-carousel-name-foreground": "#3B4548",
    "syndicate-carousel-name-selected-foreground": "#fff",
    "syndicate-details-background": "#f1f1f1",
    "syndicate-details-description-desc-foreground": "#3B4548",
    "syndicate-details-description-title-foreground": "#164D93",
    "syndicate-details-numbers-num-background": "#ffffff",
    "syndicate-details-numbers-num-bonus-background": "#ecbe13",
    "syndicate-details-numbers-num-bonus-foreground": "#3d3d3d",
    "syndicate-details-numbers-num-foreground": "#3B4548",
    "syndicate-details-numbers-title-foreground": "#164D93",
    "syndicate-details-shares-background": "#ffffff",
    "syndicate-details-shares-border": "#ecbe13",
    "syndicate-details-shares-button-background": "#ecbe13",
    "syndicate-details-shares-button-background-hover": "#dcaf07",
    "syndicate-details-shares-button-foreground": "#3d3d3d",
    "syndicate-details-shares-button-foreground-hover": "#3d3d3d",
    "syndicate-details-shares-info-foreground": "#3d3d3d",
    "syndicate-details-shares-title-foreground": "#164D93",
    "syndicate-details-sidebar-border": "#eee",
    "syndicate-details-sidebar-draws-background": "#f2f2f2",
    "syndicate-details-sidebar-draws-background-hover": "#fff",
    "syndicate-details-sidebar-draws-background-selected": "#fff",
    "syndicate-details-sidebar-draws-border": "#c9c9c9",
    "syndicate-details-sidebar-draws-check-box-background": "#fff",
    "syndicate-details-sidebar-draws-check-box-border": "#ccc",
    "syndicate-details-sidebar-draws-check-box-selected-background": "#5cb85c",
    "syndicate-details-sidebar-draws-check-box-selected-border": "#5cb85c",
    "syndicate-details-sidebar-draws-check-box-tick-background": "#fff",
    "syndicate-details-sidebar-draws-foreground": "#4a4a4a",
    "syndicate-details-sidebar-draws-price-now-foreground": "#2961A7",
    "syndicate-details-sidebar-draws-price-was-foreground": "#909090",
    "syndicate-details-sidebar-draws-save-up-background": "#2961A7",
    "syndicate-details-sidebar-draws-save-up-foreground": "#fff",
    "syndicate-details-sidebar-summary-tickets-button-add-to-cart-background": "#05ce05",
    "syndicate-details-sidebar-summary-tickets-button-add-to-cart-foreground": "#fff",
    "syndicate-details-sidebar-summary-tickets-button-add-to-cart-hover-background": "#0df90d",
    "syndicate-details-sidebar-summary-tickets-button-add-to-cart-hover-foreground": "#fff",
    "syndicate-details-sidebar-summary-tickets-button-get-tickets-background": "#05ce05",
    "syndicate-details-sidebar-summary-tickets-button-get-tickets-foreground": "#fff",
    "syndicate-details-sidebar-summary-tickets-button-get-tickets-hover-background": "#0df90d",
    "syndicate-details-sidebar-summary-tickets-button-get-tickets-hover-foreground": "#fff",
    "syndicate-details-sidebar-summary-tickets-discount-foreground": "#38af38",
    "syndicate-details-sidebar-summary-tickets-login-message-background": "#f0ad4e",
    "syndicate-details-sidebar-summary-tickets-login-message-foreground": "#fff",
    "syndicate-details-sidebar-summary-tickets-tickets-foreground": "#505050",
    "syndicate-details-sidebar-summary-tickets-total-border": "#eee",
    "syndicate-details-sidebar-summary-tickets-total-foreground": "#505050",
    "syndicate-details-totals-background": "#e6e6e6",
    "syndicate-details-totals-label-foreground": "#3B4548",
    "syndicate-details-totals-value-foreground": "#3B4548",
    "syndicate-step-1-background": "#fff",
    "syndicate-step-1-description-desc-foreground": "#3B4548",
    "syndicate-step-1-description-title-foreground": "#3B4548",
    "syndicate-step-1-numbers-num-background": "#fff",
    "syndicate-step-1-numbers-num-bonus-background": "#fbc100",
    "syndicate-step-1-numbers-num-bonus-foreground": "#fff",
    "syndicate-step-1-numbers-num-foreground": "#3B4548",
    "syndicate-step-1-numbers-title-foreground": "#3B4548",
    "syndicate-step-1-shares-background": "#fff",
    "syndicate-step-1-shares-border": "#2961A7",
    "syndicate-step-1-shares-button-background": "#2961A7",
    "syndicate-step-1-shares-button-background-hover": "#144179",
    "syndicate-step-1-shares-button-foreground": "#fff",
    "syndicate-step-1-shares-button-foreground-hover": "#fff",
    "syndicate-step-1-shares-info-foreground": "#8c8b8b",
    "syndicate-step-1-shares-title-foreground": "#3B4548",
    "syndicate-step-1-totals-background": "#f2f2f2",
    "syndicate-step-1-totals-label-foreground": "#8c8b8b",
    "syndicate-step-1-totals-value-foreground": "#3B4548",
    "syndicate-step-2-draw-background": "#fff",
    "syndicate-step-2-draw-background-shadow": "#2961A7",
    "syndicate-step-2-draw-best-value-background": "#fff",
    "syndicate-step-2-draw-best-value-background-shadow": "#fbc100",
    "syndicate-step-2-draw-check-box-background": "#fff",
    "syndicate-step-2-draw-check-box-border": "#ccc",
    "syndicate-step-2-draw-check-box-selected-background": "#5cb85c",
    "syndicate-step-2-draw-check-box-selected-border": "#5cb85c",
    "syndicate-step-2-draw-check-box-tick-background": "#fff",
    "syndicate-step-2-draw-save-up-background": "#72b001",
    "syndicate-step-2-draw-save-up-foreground": "#fff",
    "syndicate-step-2-draws-background": "#f2f2f2",
    "syndicate-step-3-purchase-tickets-background": "#2961A7",
    "syndicate-step-3-purchase-tickets-button-add-to-cart-background": "#fbc100",
    "syndicate-step-3-purchase-tickets-button-add-to-cart-foreground": "#3B4548",
    "syndicate-step-3-purchase-tickets-button-add-to-cart-hover-background": "#e0ac00",
    "syndicate-step-3-purchase-tickets-button-add-to-cart-hover-foreground": "#3B4548",
    "syndicate-step-3-purchase-tickets-button-get-tickets-background": "#72b001",
    "syndicate-step-3-purchase-tickets-button-get-tickets-foreground": "#fff",
    "syndicate-step-3-purchase-tickets-button-get-tickets-hover-background": "#5b8a05",
    "syndicate-step-3-purchase-tickets-button-get-tickets-hover-foreground": "#fff",
    "syndicate-step-3-purchase-tickets-fallback-foreground": "#fff",
    "syndicate-step-3-purchase-tickets-login-message-background": "#c0392b",
    "syndicate-step-3-purchase-tickets-login-message-foreground": "#fff",
    "syndicate-step-3-purchase-tickets-tickets-foreground": "#fff",
    "syndicate-step-3-purchase-tickets-total-foreground": "#fff",
    "syndicate-step-count-background": "#2961A7",
    "syndicate-step-count-foreground": "#fff",
    "syndicate-step-title-foreground": "#3B4548",
    "syndicate-switch-pages-background": "#e6e6e6",
    "syndicate-switch-pages-foreground": "#3B4548",
    "syndicate-switch-pages-selected-background": "#164D93",
    "syndicate-switch-pages-selected-foreground": "#ffffff",
};
